<!--Select Data to View-->
<div class="OptionMenu">
	<h4 style="grid-column: 1 / 3; text-align: center">Select Option</h4>

	<label>Option:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstOption"
		[(ngModel)]="SelectedOption"
		optionLabel="Desc"
		[filter]="true"
		filterBy="Desc"
		[showClear]="false"
		placeholder="Select an Option"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedOption">
				<div class="form-control NoBorder" style="text-align: left">{{ SelectedOption.Desc }}</div>
			</div>
		</ng-template>
		<ng-template let-OptionItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">{{ OptionItem.Desc }}</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

<!--Schools and Role Counts-->
<div *ngIf="SelectedOption.ID == 1">
	<caass-role-su-school-maintenance></caass-role-su-school-maintenance>
</div>

<!--District Level Users-->
<div *ngIf="SelectedOption.ID == 2">
	<caass-role-su-district-users></caass-role-su-district-users>
</div>

<!--Users By Role-->
<div *ngIf="SelectedOption.ID == 3">
	<caass-role-su-user-by-role></caass-role-su-user-by-role>
</div>

<!--Users assigned multiple schools-->
<div *ngIf="SelectedOption.ID == 4">
	<caass-role-su-user-multiple-schools></caass-role-su-user-multiple-schools>
</div>

<!--Users with no home school-->
<div *ngIf="SelectedOption.ID == 5">
	<caass-role-su-user-no-roles></caass-role-su-user-no-roles>
</div>

<!--Users assigned inactive staff-->
<div *ngIf="SelectedOption.ID == 6">
	<caass-role-su-user-inactive-staff></caass-role-su-user-inactive-staff>
</div>
